import { noop, over } from 'lodash-es';
import React, { useState } from 'react';
import ForgotPasswordRequestCard, {
  ForgotPasswordRequestCardProps,
} from '../ForgotPasswordRequestCard/ForgotPasswordRequestCard';
import ForgotPasswordSuccessCard from '../ForgotPasswordSuccessCard/ForgotPasswordSuccessCard';

export interface ForgotPasswordCardProps
  extends Pick<ForgotPasswordRequestCardProps, 'onSubmit' | 'onSuccess'> {}

/**
 * A card that prompts a user to enter their email in order to reset their password.
 * Once the request is fulfilled, a "success" card is shown, telling the user to
 * check their email.
 *
 * The email should contain a direct link to the "reset-password" page
 */
export const ForgotPasswordCard: React.FC<ForgotPasswordCardProps> = ({
  onSubmit,
  onSuccess = noop,
}) => {
  const [isRequestSuccessful, setIsRequestSuccessful] = useState(false);

  if (!isRequestSuccessful) {
    return (
      <ForgotPasswordRequestCard
        onSubmit={onSubmit}
        onSuccess={over([() => setIsRequestSuccessful(true), onSuccess])}
      />
    );
  }

  return <ForgotPasswordSuccessCard />;
};

export default ForgotPasswordCard;
